import { render, staticRenderFns } from "./business_organization.vue?vue&type=template&id=2a8a1b46&scoped=true&"
import script from "./business_organization.vue?vue&type=script&lang=js&"
export * from "./business_organization.vue?vue&type=script&lang=js&"
import style0 from "./business_organization.vue?vue&type=style&index=0&id=2a8a1b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a1b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8a1b46')) {
      api.createRecord('2a8a1b46', component.options)
    } else {
      api.reload('2a8a1b46', component.options)
    }
    module.hot.accept("./business_organization.vue?vue&type=template&id=2a8a1b46&scoped=true&", function () {
      api.rerender('2a8a1b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/knowledge_base/form/components/business_organization.vue"
export default component.exports